import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

export function SignInPage(_props: { go: (p: any) => void }) {
  const { signInWithGoogle } = useAuth();
  const [busy, setBusy] = useState(false);

  const continueWithGoogle = async () => {
    setBusy(true);
    try {
      await signInWithGoogle();
    } catch {
      toast.error('Google sign-in is unavailable. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-card">
      <h2 className="text-white mb-2">Sign in</h2>
      <p className="text-cyan-300 mb-8">Use your Google account to access your courses and study groups.</p>
      <Button variant="outline" className="w-full" disabled={busy} onClick={continueWithGoogle}>
        {busy ? 'Connecting…' : 'Continue with Google'}
      </Button>
      <p className="text-cyan-200 mt-6 text-sm text-center">
        New accounts are created automatically when you continue with Google.
      </p>
    </div>
  );
}
